import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

type HeadProps = {
  page?: string | null;
};

export const Head = ({ page = null }: HeadProps = {}) => {
  const { t } = useTranslation();
  const title = page ? t('Head.title' + page) : t('Head.titleDefault');
  const description = page ? t('Head.description' + page) : t('Head.descriptionDefault');

  return (
    <Helmet title={title} defaultTitle={title}>
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta name="description" content={description} />
      <meta name="author" content="MDirector" />
      <meta name="copyright" content={t('Head.copyright')} />

      <meta property="og:locale" content={t('Head.locale')} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content="https://www.mdirector.com/" />
      <meta property="og:site_name" content="MDirector" />
    </Helmet>
  );
};
